import { ElectricalDeviceType } from "building-types/electrical/electricalDeviceTypesEnum";

export const electricalDeviceTypeToPrettyName: { [deviceType in ElectricalDeviceType]: string } = {
  [ElectricalDeviceType.LOAD]: "Electrical Load",
  [ElectricalDeviceType.CONTROLLER]: "Electrical Controller",
};
